module.exports = __webpack_public_path__ + "img/card-bg2@3x.d71c0886.png";